import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from '../../../../Common';
import services from "../services";
import $ from "jquery";
import authService from "../../../Common/services";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import Joi from "@hapi/joi";
import { BlockImageReportSchemaObject } from "../BlockImageReportSchema";
import { validateProperty, validate } from "../../../Common";
import tokenService from "../../../../Common/tokenDecoder";
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import '../../../Common/Table/table.css';
import xlsx from 'json-as-xlsx';
import './printScale.css';
import _, { forEach } from 'lodash';
import moment from 'moment';
import Paper from '@material-ui/core/Paper';
import TablePagination from '@material-ui/core/TablePagination';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { makeStyles } from '@material-ui/core/styles';

const screenCode = "BLOCKIMAGEREPORT";
const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
    dialog1: {
        width: 850,
    }
});

export function BlockImageReport(props) {

    const componentRef = useRef();
    const classes = useStyles();
    const [groups, setGroups] = useState([]);
    const [fields, setFields] = useState([]);
    const [blocks, setBlocks] = useState([]);
    const [estates, setEstates] = useState([]);
    const [divisions, setDivisions] = useState([]);
    const [taskCategory, setTaskCategory] = useState();
    const [labourTask, setLabourTask] = useState()
    const [gtnnumber, setGtnnumber] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);
    const [totalAmount, setTotalAmount] = useState();
    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(0);

    const [blockImageReport, setBlockImageReport] = useState({
        groupID: "0",
        estateID: "0",
        divisionID: "0",
        searchDate: "",
        fieldID: "0",
        blockID: "0"
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "0",
        estate: "0",
        division: "0",
        searchDate: "",
        regNo: "0",
        field: "0",
        block: "0"
    })
    const [csvData, setCsvData] = useState([]);

    const [errors, setErrors] = useState({});

    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false,
    });

    const [isReportButtonsEnabled, setIsReportButtonsEnabled] = useState(false);
    const [buttonHide, setButtonHide] = useState(true);

    const schema = Joi.object(BlockImageReportSchemaObject).options({ allowUnknown: true });
    const contentRowNames = ["regNumber", "supplierName", "fieldName", "blockName", "sessionName", "quantity"]
    const csvHeaders = [
        { label: "Reg No", value: "regNumber" },
        { label: "Name", value: "supplierName" },
        { label: "Field", value: "fieldName" },
        { label: "Block", value: "blockName" },
        { label: "Session", value: "sessionName" },
        { label: "Qunatity", value: "quantity" }
    ];

    const [reportData, setReportData] = useState([]);
    const [reportDataOne, setReportDataOne] = useState([]);
    const [keys, setKeys] = useState([]);

    const handleLimitChange = (event) => {
        setLimit(event.target.value);
    };
    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    useEffect(() => {
        trackPromise(getPermissions(),
            getGroupsForDropdown(),

        );
    }, []);

    useEffect(() => {
        trackPromise(
            getEstatesForDropdown(),

        )
    }, [blockImageReport.groupID])

    useEffect(() => {
        trackPromise(
            getDivisionsForDropDown(),
        )
    }, [blockImageReport.estateID])

    useEffect(() => {
        trackPromise(
            getGtnNumberForDropDown()
        )
    }, [blockImageReport.searchDate])

    useEffect(() => {
        trackPromise(
            getFeildsByCollectionPoint()
        )
    }, [blockImageReport.divisionID]);

    useEffect(() => {
        trackPromise(
            getBlocksByField()
        )
    }, [blockImageReport.fieldID]);

    useEffect(() => {
    }, [reportData]);

    function clearTable() {
        setIsTableHide(true);
        setIsReportButtonsEnabled(false);
        setReportData([]);
    }

    function handleGroupChange(target) {
        validateInputs(target);

        setBlockImageReport({
            ...blockImageReport,
            groupID: target.value,
            estateID: "0",
            divisionID: "0"

        });
    }

    function handleEstateChange(target) {
        validateInputs(target);

        setBlockImageReport({
            ...blockImageReport,
            estateID: target.value,
            divisionID: "0"

        });
    }

    function handleDivisionChange(target) {
        validateInputs(target);

        setBlockImageReport({
            ...blockImageReport,
            divisionID: target.value

        });
    }

    function handleSearchDateChange(target) {
        validateInputs(target);

        setBlockImageReport({
            ...blockImageReport,
            searchDate: target.value

        });
    }

    function handleFieldChange(target) {
        validateInputs(target);

        setBlockImageReport({
            ...blockImageReport,
            fieldID: target.value
        });
        clearTable();
    }

    function handleBlockChange(target) {
        validateInputs(target);

        setBlockImageReport({
            ...blockImageReport,
            blockID: target.value
        });
        clearTable();
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, BlockImageReportSchemaObject);
        errorMessage
            ? (error[target.name] = errorMessage)
            : delete error[target.name];

        setErrors(error);
    }


    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWBLOCKIMAGEREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');


        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled:
                isOperationEntityFilterEnabled !== undefined,
        });

        var token = tokenService.getUserDetailsFromToken();

        setBlockImageReport({
            ...blockImageReport,
            groupID: token.groupID,
            estateID: token.operationEntityID
        });

        trackPromise(getGroupsForDropdown());
    }


    function destroyDataTable() {
        keys.forEach(e => {
            $(`#${e}`).DataTable().destroy();
        })
    }

    function createDataTable() {
        keys.forEach(e => {
            $(`#${e}`).DataTable();
        })
    }

    async function getGroupsForDropdown() {
        const result = await services.getAlGroupsForDropdown();
        setGroups(result);
    }

    async function getEstatesForDropdown() {
        const result = await services.GetAllOperationEntityByGroupID(blockImageReport.groupID);
        setEstates(result);
    }

    async function getDivisionsForDropDown() {
        const data = await services.getDivisionByEstateID(blockImageReport.estateID);
        setDivisions(data);
    }

    async function getGtnNumberForDropDown() {
        const data = await services.getGtnNumberByCollectionPointIDandDate(blockImageReport);
        setGtnnumber(data);
    }

    async function getFeildsByCollectionPoint() {
        const fields = await services.GetFieldsByCollectionPointID(parseInt(blockImageReport.divisionID));
        setFields(fields);
    }

    async function getBlocksByField() {
        const blocks = await services.GetBlocksByFieldID(parseInt(blockImageReport.fieldID));
        setBlocks(blocks);
    }


    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(
                    <MenuItem key={key} value={key}>
                        {value}
                    </MenuItem>
                );
            }
        }
        return items;
    }

    async function handleSearch(e) {

        e.preventDefault();

        setIsTableHide(true);

        setButtonHide(true);

        getSelectedDropdownValuesForReport(blockImageReport);

        setIsTableHide(true);
        const result = await services.GetBlockImageReportData(blockImageReport);
        const totalAmount = result.reduce((totalAmount, item) => totalAmount + item.quantity, 0)
        setTotalAmount(totalAmount);
        let groupedResult = groupByGtn(result);
        let keys = Object.keys(groupedResult);

        setKeys(keys);
        setReportData(result);
        setReportDataOne(groupedResult);

        if (result.length > 0) {
            result.forEach(x => {
                x.startTime = moment(x.startTime).format('h:mm:ss a');
                x.endTime = moment(x.endTime).format('h:mm:ss a');
            })
            setIsTableHide(false);
            setIsReportButtonsEnabled(true);
        } else {
            setIsReportButtonsEnabled(false);
        }


        setButtonHide(false);
        setIsReportButtonsEnabled();

        const comlpeteData = [...result];
        setCsvData(comlpeteData)
    }

    function createFile() {
        var settings = {
            sheetName: 'Block Image Report',
            fileName: 'Block Image Report',
            writeOptions: {}
        }
        var copyOfCsv = _.cloneDeep(csvData)
        var newRow1 = {
            regNumber: "total",
            quantity: totalAmount
        }
        var newRow2 = {
            regNumber: "Group :" + groups[blockImageReport.groupID],
            supplierName: "Operation Entity : " + estates[blockImageReport.estateID],
            fieldName: "Collection Point : " + divisions[blockImageReport.divisionID],
            blockName: "Field : " + fields[blockImageReport.fieldID],
            sessionName: "Block : " + blocks[blockImageReport.blockID],
            quantity: "Date : " + blockImageReport.searchDate
        }
        copyOfCsv.push(newRow1)
        copyOfCsv.push({}, newRow2)
        xlsx(csvHeaders, copyOfCsv, settings, true)
    }


    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            estate: estates[searchForm.estateID],
            division: divisions[searchForm.divisionID],
            field: fields[searchForm.fieldID],
            block: blocks[searchForm.blockID],
            date: searchForm.searchDate
        })
    }

    function groupByGtn(objectArray) {
        return objectArray.reduce(function (acc, obj) {
            let key = obj['gtnNumber']
            if (!acc[key]) {
                acc[key] = []
            }
            acc[key].push(obj)
            return acc
        }, {})
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">

                        <PageHeader
                            title="Block Image Report"
                            isButtonEnable={permissionList.isAddEditEnabled}
                        />
                        <div className="card-body">
                            <form
                                onSubmit={(e) => handleSearch(e)}
                                disabled={false}
                            >
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            value={blockImageReport.groupID}
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            onChange={(e) => handleGroupChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && (
                                            <FormHelperText error>{errors["groupID"]}</FormHelperText>
                                        )}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="estateID"> Operation Entity *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="estateID"
                                            id="estateID"
                                            name="estateID"
                                            value={blockImageReport.estateID}
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            onChange={(e) => handleEstateChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                            {generateDropDownMenu(estates)}
                                        </Select>
                                        {errors["estateID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["estateID"]}</FormHelperText>)}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="">Collection Point *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="divisionID"
                                            id="divisionID"
                                            name="divisionID"
                                            value={blockImageReport.divisionID}
                                            onChange={(e) => handleDivisionChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Collection Point--</MenuItem>
                                            {generateDropDownMenu(divisions)}
                                        </Select>
                                        {errors["divisionID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["divisionID"]}</FormHelperText>)}
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="searchDate">Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="searchDate"
                                            name="searchDate"
                                            type="date"
                                            onChange={(e) => handleSearchDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["searchDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["searchDate"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="fieldID">Field</InputLabel>
                                        <Select fullWidth
                                            id="fieldID"
                                            name="fieldID"
                                            value={blockImageReport.fieldID}
                                            onChange={(e) => handleFieldChange(e.target)}>
                                            <MenuItem value="0">--Select Field--</MenuItem>
                                            {generateDropDownMenu(fields)}
                                        </Select>
                                        {errors["fieldID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["fieldID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="blockID">Block</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="blockID"
                                            id="blockID"
                                            name="blockID"
                                            value={blockImageReport.blockID}
                                            onChange={(e) => handleBlockChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Sub Field--</MenuItem>
                                            {generateDropDownMenu(blocks)}
                                        </Select>
                                        {errors["blockID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["blockID"]}</FormHelperText>)}
                                    </div>
                                </div>

                                <div className="card-footer">
                                    <input
                                        type="button"
                                        className="btn btn-primary"
                                        value="Search"
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />
                                </div>
                            </form>

                            {isTableHide ? null :
                                <div>
                                    <TableContainer component={Paper}>
                                        <Table className={classes.table} aria-label="simple table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>Reg No</TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>Name</TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>Field</TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>Block</TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>Session</TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>Image</TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>Qunatity (Kg)</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {reportData.slice(page * limit, page * limit + limit).map((row, i) => (
                                                    <TableRow key={i}>
                                                        <TableCell component="th" scope="row" align="left"> {row.regNumber}</TableCell>
                                                        <TableCell component="th" scope="row" align="left"> {row.supplierName}</TableCell>
                                                        <TableCell component="th" scope="row" align="left"> {row.fieldName}</TableCell>
                                                        <TableCell component="th" scope="row" align="left"> {row.blockName}</TableCell>
                                                        <TableCell component="th" scope="row" align="left"> {row.sessionName}</TableCell>
                                                        <TableCell component="th" scope="row" align="center">
                                                            {row.image && (<img src={`data:employeeImage/jpeg;base64,${row.image}`} width="150" height="150"></img>)}</TableCell>
                                                        <TableCell component="th" scope="row" align="center"> {row.quantity}</TableCell>
                                                    </TableRow>

                                                )
                                                )}

                                            </TableBody>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell colSpan={6} align="left" style={{ fontWeight: "bold" }}>Total</TableCell>
                                                    <TableCell component="th" scope="row" align="center" style={{ fontWeight: "bold" }}> {totalAmount}</TableCell>
                                                </TableRow>

                                            </TableHead>

                                        </Table>
                                        <TablePagination
                                            component="div"
                                            count={reportData.length}
                                            onChangePage={handlePageChange}
                                            onChangeRowsPerPage={handleLimitChange}
                                            page={page}
                                            rowsPerPage={limit}
                                            rowsPerPageOptions={[5, 10, 25]}
                                        />
                                    </TableContainer>
                                    <div className="pt-2">
                                        <input
                                            type="button"
                                            className="btn btn-primary pull-right ml-2"
                                            value="Excel"
                                            onClick={createFile}
                                        />
                                        <ReactToPrint
                                            documentTitle={"Field Wise Block Plucking Details"}
                                            trigger={() => <input
                                                type="submit"
                                                className="btn btn-primary pull-right ml-2"
                                                value="PDF"

                                            />}
                                            content={() => componentRef.current}
                                        />
                                    </div>
                                    <div hidden={true}>
                                        <CreatePdf ref={componentRef} reportData={reportData} dataOne={reportDataOne}
                                            rowNames={contentRowNames} searchData={selectedSearchValues} keys={keys} totalAmount={totalAmount} />
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}
